// Memoria del día/semana/mes que el usuario está mirando en la Agenda.
//
// Por qué existe: las acciones internas de la agenda (ingresar reserva,
// bloquear horarios, editar horarios de trabajo) son rutas propias
// (`/agenda/ingresar-reserva`, `/agenda/bloquear-horarios`,
// `/agenda/horarios-de-trabajo`) y la Agenda es lazy, así que entrar a una
// acción y volver REMONTA el componente y la fecha saltaba a "hoy". Guardando
// el período navegado acá, sobrevive ese ida-y-vuelta.
//
// Se limpia al salir de la familia `/agenda` (lo dispara RouterContent) para que
// reabrir la Agenda desde otra sección muestre hoy / semana actual / mes actual.
//
// Módulo liviano a propósito (solo localStorage, sin imports pesados): el Router
// lo importa de forma directa SIN arrastrar el chunk lazy de Agenda al bundle
// principal.
const AGENDA_DATE_KEY = 'agenda:date';

export const readPersistedAgendaDate = (): Date | null => {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(AGENDA_DATE_KEY);
  if (!raw) return null;
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const writePersistedAgendaDate = (date: Date): void => {
  try {
    window.localStorage.setItem(AGENDA_DATE_KEY, date.toISOString());
  } catch {
    /* localStorage lleno o no disponible (modo privado) → no es crítico */
  }
};

export const clearPersistedAgendaDate = (): void => {
  try {
    window.localStorage.removeItem(AGENDA_DATE_KEY);
  } catch {
    /* ignore */
  }
};
